import $ from 'jquery';

import './_cameradialog.sass';

import Class from '../legacy-class';

import ProgressCircle from './progress-circle';

import '../../../../mui/dialog';
import '../../../../mui/checkbox';
import {rusDateTime} from '../../../../utils/time';
import {openCameraContentDialog} from '../../../entities/device.photos/model/get-photos-by-period-action';
import {getIdleState} from '../../../idle/selectors';

var _CameraTimeout = 15;
var _CameraWakeInterval = 10;

export default Class.Singleton(
    Class({
        init: function () {
            this._ui = null;
        },

        _create: function (ui) {
            this._ui = ui;

            this._element = $(
                '<div class="ui-camera-dialog" style="display: none">' +
                    '<h1 class="mui_dialog_title large">Камера</h1>' +
                    '<div class="image-container">' +
                    '<img class="image hidden"/>' +
                    '<div class="loading">Запрос снимка...</div>' +
                    '<div class="device-offline hidden">Устройство не на связи</div>' +
                    '</div>' +
                    '<div class="ui-camera-dialog-settings">' +
                    '<span class="ui-camera-dialog-stretch mui_checkbox">' +
                    '<span class="mui_checkbox_icon"></span>' +
                    'растягивать снимок' +
                    '</span>' +
                    '<label class="ui-camera-dialog-quality">' +
                    'качество: ' +
                    '<select name="quality">' +
                    '<option value="0">низкое</option>' +
                    '<option value="1">среднее</option>' +
                    '<option value="2">высокое</option>' +
                    '</select>' +
                    '</label>' +
                    '<label class="ui-camera-dialog-number">' +
                    'камера: ' +
                    '<select name="number">' +
                    '</select>' +
                    '</label>' +
                    '</div>' +
                    '</div>'
            )
                .find('.ui-camera-dialog-stretch')
                .toggleClass(
                    'mui_checkbox_checked',
                    this._ui.settings.data().camerashot_stretch != false
                )
                .on(
                    'change',
                    function (e) {
                        var checked = !!this._element
                            .find('.ui-camera-dialog-stretch')
                            .hasClass('mui_checkbox_checked');
                        this._element.find('.image').toggleClass('stretch', checked); //.load()
                        this._handleImageResize();
                        this._ui.settings.set({camerashot_stretch: checked});
                    }.bind(this)
                )
                .end()

                .find('[name="quality"]')
                //.val(this._ui.settings.data().camerashot_quality || 0)
                .on(
                    'change',
                    function (e) {
                        this._wakeCameraWithParams();
                        if (this._ui.settings) {
                            var q = this._element.find('[name="quality"]').val();
                            var modifier = {camerashot_quality: {}};
                            modifier.camerashot_quality[this.device().id()] = q;
                            this._ui.settings.set(modifier);
                        }
                    }.bind(this)
                )
                .end()

                .find('[name="number"]')
                .on(
                    'change',
                    function (e) {
                        this._wakeCameraWithParams();
                        if (this._ui.settings) {
                            var n = this._element.find('[name="number"]').val();
                            var modifier = {camera_number: {}};
                            modifier.camera_number[this.device().id()] = n;
                            this._ui.settings.set(modifier);
                        }
                    }.bind(this)
                )
                .end()

                .find('.image')
                .on(
                    'load',
                    function () {
                        var image = this._element.find('.image');

                        if (image.attr('nextsrc')) {
                            image
                                .attr({
                                    src: image.attr('nextsrc'),
                                    nextsrc: '',
                                })
                                .prop('camera-loading', true);
                        } else image.prop('camera-loading', false);

                        if (image.attr('src') == '') return;

                        image.removeClass('hidden');
                        this._element.find('.loading').addClass('hidden');

                        this._handleImageResize();
                    }.bind(this)
                )
                .on(
                    'error',
                    function () {
                        this._element.find('.image').addClass('hidden');

                        var offline = this.device() && this.device().online() == false;

                        this._element.find('.loading').toggleClass('hidden', offline);
                        this._element
                            .find('.device-offline')
                            .toggleClass('hidden', !offline);
                    }.bind(this)
                )
                .end();

            this._element
                .find('.image')
                .toggleClass(
                    'stretch',
                    this._ui.settings.data().camerashot_stretch != false
                );

            this._element
                .find('[name="quality"]')
                .val(this._ui.settings.data().camerashot_quality);

            this._progress = new ProgressCircle();
            this._element.find('.image-container').append(this._progress.element());

            this._ui.devices.bind(
                'selectedDeviceEvent',
                function (device, eventname, data) {
                    if (eventname == 'camerashot_progress') {
                        this._progress.progress(data.progress);
                    }

                    if (eventname == 'camerashot_ready') {
                        var img = this._element.find('img');
                        var url = this._make_url(device, data.shot_id);

                        if (!img.prop('camera-loading'))
                            img.attr('src', url).prop('camera-loading', true);
                        else img.attr('nextsrc', url);
                        this._element.removeClass('empty');

                        this.filename(data.filename);
                        this.orientation(data.orientation);
                    }

                    if (eventname == 'camera_available')
                        this.available(device.camera_available());
                }.bind(this)
            );

            this._wakeTimer = null;

            this._updateTimerActivity.bind(this);
        },

        _make_url: function (device, shot_id) {
            var data = {device_id: device.id()};
            if (shot_id != null) data.shot_id = shot_id;
            return this._ui.api.get_url('get_camerashot', data, true);
        },

        open: function (ui, device) {
            if (!this._ui) this._create(ui);

            if (device) this.device(device);

            this.active(true);

            this._element.mui_dialog({
                buttons: [
                    {
                        text: 'Фотографии с камеры',
                        click: function () {
                            this._ui.store.dispatch(openCameraContentDialog());
                        }.bind(this),
                    },
                    {
                        text: 'закрыть',
                        click: function () {
                            this._element.mui_dialog('close');
                        }.bind(this),
                    },
                ],

                close: function () {
                    this.active(false);
                }.bind(this),
            });
        },

        _updateTimerActivity: function () {
            const idle = getIdleState(this._ui.store.getState());

            const enable = this.active() && this._ui.comet.active() && !idle;

            if (enable) {
                if (this._wakeTimer == null) {
                    this._wakeTimer = setInterval(
                        this._onWakeTimer.bind(this),
                        _CameraWakeInterval * 1000
                    );
                    // this._onWakeTimer()
                    // this._wakeCameraWithParams()
                }
            } else {
                if (this._wakeTimer) {
                    clearInterval(this._wakeTimer);
                    this._wakeTimer = null;
                }
            }
        },

        _onWakeTimer: function () {
            if (this.device() && this.device().online()) {
                this.device().wake_camera(_CameraTimeout);

                var offline_label = this._element.find('.device-offline');
                if (!offline_label.hasClass('hidden')) {
                    offline_label.addClass('hidden');
                    this._element.find('.loading').removeClass('hidden');
                }
            }
        },

        _wakeCameraWithParams: function () {
            if (this.device()) {
                var q = this._element.find('[name="quality"]').val();
                var n = this._element.find('[name="number"]').val();
                this.device().wake_camera(_CameraTimeout, q, n);
            }
        },

        _reTime: /^(\d+)[.:-](\d+)[.:-](\d+)\s(\d+)[.:-](\d+)[.:-](\d+)/,
        _parseDateFromFilename: function (filename) {
            var match = this._reTime.exec(filename);
            if (match)
                return rusDateTime(
                    new Date(
                        match[1] < 100 ? ~~match[1] + 2000 : match[1],
                        match[2] - 1,
                        match[3],
                        match[4],
                        match[5],
                        match[6]
                    ),
                    true
                );
        },

        _updateTitle: function () {
            var title = this._element.find('.mui_dialog_title');

            if (!this.available()) title.text('Камера недоступна');
            else title.text('Камера ' + this.shottime());
        },

        shottime: function () {
            return this._parseDateFromFilename(this.filename()) || this.filename();
        },

        _handleImageResize: function () {
            var image = this._element.find('.image');
            var parent = image.parent();

            if (!image.get(0).naturalWidth) return;

            var containerWidth = parent.outerWidth();
            var containerHeight = parent.outerHeight();

            var naturalWidth = image.get(0).naturalWidth;
            var naturalHeight = image.get(0).naturalHeight;

            var transform = '';
            var transformedWidth = naturalWidth;
            var transformedHeight = naturalHeight;
            switch (this.orientation()) {
                case 1: // Horizontal (normal)
                    break;
                case 2: // Mirrored horizontal
                    transform = 'scale(-1, 1)';
                    break;
                case 3: // Rotated 180
                    transform = 'rotate(180deg)';
                    break;
                case 4: // Mirrored vertical
                    transform = 'scale(1, -1)';
                    break;
                case 5: // Mirrored horizontal then rotated 90 CCW
                    transform = 'scale(-1, 1) rotate(90deg)';
                    transformedWidth = naturalHeight;
                    transformedHeight = naturalWidth;
                    break;
                case 6: // Rotated 90 CCW
                    transform = 'rotate(90deg)';
                    transformedWidth = naturalHeight;
                    transformedHeight = naturalWidth;
                    break;
                case 7: // Mirrored horizontal then rotated 90 CW
                    transform = 'scale(-1, 1) rotate(-90deg)';
                    transformedWidth = naturalHeight;
                    transformedHeight = naturalWidth;
                    break;
                case 8: // Rotated 90 CW
                    transform = 'rotate(-90deg)';
                    transformedWidth = naturalHeight;
                    transformedHeight = naturalWidth;
                    break;
            }

            var scale = Math.min(
                containerWidth / transformedWidth,
                containerHeight / transformedHeight
            );

            if (!image.hasClass('stretch')) scale = Math.min(1, scale);

            var scaledWidth = naturalWidth * scale;
            var scaledHeight = naturalHeight * scale;

            image.css({
                width: scaledWidth,
                height: scaledHeight,
                position: 'absolute',
                left: (containerWidth - scaledWidth) / 2,
                top: (containerHeight - scaledHeight) / 2,

                '-webkit-transform': transform,
                '-moz-transform': transform,
                '-ms-transform': transform,
                '-o-transform': transform,
                transform: transform,
            });
        },
    })
).implement(
    Class.Properties({
        device: {
            set: function (value) {
                this._device = value;

                var url = '';
                // if (this._device)
                //     url = this._make_url(this._device)
                // Without clearing src first, Chrome displays previous image until new one is loaded
                this._element.find('.image').addClass('hidden').attr('src', url);
                this.filename('');
                this.orientation(null);
                if (this._element.find('.image').get(0).complete) {
                    // this._element.find('.image').load();
                }
                this._ui.api
                    .call_v2({
                        method: 'get_last_camerashot_meta',
                        data: {
                            device_id: this._device.id(),
                            meta: true,
                        },
                    })
                    .then((json) => {
                        // json could be null if server returned "204 No Content" if there is no shot available
                        if (json && json.shot_id)
                            this._element
                                .find('.image')
                                .addClass('hidden')
                                .attr(
                                    'src',
                                    this._make_url(this._device, json.shot_id)
                                );
                        this.filename(json.filename);
                        this.orientation(json.orientation);
                    });

                this.available(this._device.camera_available());
                var quality =
                    this._ui.settings &&
                    this._ui.settings.data().camerashot_quality &&
                    this._ui.settings.data().camerashot_quality[this._device.id()];
                this._element.find('[name="quality"]').val(quality || 0);
                this._progress.progress(0, false);
                var number =
                    this._ui.settings &&
                    this._ui.settings.data().camera_number &&
                    this._ui.settings.data().camera_number[this._device.id()];

                var options = [];
                for (var i = 0, count = this._device.camera_count(); i < count; i++)
                    options.push(
                        '<option value="' + i + '">камера №' + (i + 1) + '</option>'
                    );
                this._element
                    .find('[name="number"]')
                    .html(options.join('\n'))
                    .val(number || 0);
                this._wakeCameraWithParams();
            },
        },

        active: {
            value: false,

            set: function (value) {
                this._active = value;
                this._updateTimerActivity();
            },
        },

        filename: {
            set: function (value) {
                this._filename = value;
                this._updateTitle();
            },
        },

        orientation: {
            value: null,
            set: function (value) {
                this._orientation = value;
                this._handleImageResize();
            },
        },

        available: {
            set: function (value) {
                this._available = !!value;
                this._element
                    .find('.mui_dialog_title')
                    .toggleClass('unavailable', !value);
                this._updateTitle();
            },
        },

        quality: {
            set: function (value) {
                this._quality = value;

                this._wakeCameraWithParams();
            },
        },
    })
);
